import React, { useContext, useEffect, useState } from "react";
import SentimentDrivers from "../SentimentDriver/SentimentDriver";
import CompetitiveSummary from "../CompetitiveSummary/CompetitiveSummary";
import { LLM_OPTIONS } from "../../../utils/constant";
import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import classes from "./CompetitiveOverview.module.css";
import MUISelect from "../../../Component/UI/MUISelect/MUISelect";
import CategoryDimensions from "../CategoryDimensions/CategoryDimensions";
import CoreAttributes from "../CoreAttributes/CoreAttributes";
import Taxonomy from "../Taxonomy/Taxonomy";
import AttributesOverview from "../CompAttributes/CompAttributes";
import { filterKey } from "../BrandAudit";
import Checkbox from "@mui/material/Checkbox";
import { tab } from "../BrandScore/BrandScore";

export default function CompetitiveOverview() {
  const discoveryCtx = useContext(DiscoveryContext);
  let categories = discoveryCtx.category;
  const entity = discoveryCtx.entity;
  const selectedCategory = discoveryCtx.state.selectedCategory;
  const selectedLLM = discoveryCtx.state.selectedLLM;
  let competitors = discoveryCtx.competitors[selectedCategory].map((c) => c.name);
  competitors.unshift(entity);
  const selectedCompetitor = discoveryCtx.state.selectedCompetitor;
  console.log("CompetitiveOverview", selectedCompetitor);



 
  return (
    <>
    <div className={classes.containerWrapper}>
      <CompetitiveSummary />
      <div className={classes.headerWrapper}>
        <h5 className={classes.heading}>Sentiment Drivers</h5>
      <div className={classes.dropdownWrapper}>
        <MUISelect
          fullWidth={false}
          optionValue={discoveryCtx.state.selectedLLM}
          label={"LLM"}
          id={filterKey.llm}
          options={(discoveryCtx.llm || []).map((llm) => {
            const match = LLM_OPTIONS.find((option) => option.value === llm);
            return {
              name: match ? match.name : llm,
              value: llm,
            };
          })}
          onChange={(e) => {
            discoveryCtx.updateSelectedLLM(e.target.value);
          }}
        />
        <MUISelect
          fullWidth={false}
          optionValue={selectedCompetitor}
          label={"Competitor"}
          id={filterKey.competitor}
          options={(competitors || []).map((competitor, index) => {
            return {
              name: competitor,
              value: index,
            };
          })}
          onChange={(e) => {
            discoveryCtx.updateSelectedCompetitor(e.target.value);
          }}
        />
      </div>
      </div>
      <SentimentDrivers selectedCompetitor={selectedCompetitor} />
      <TaxonomyAndCoreAttributes selectedCategory={selectedCategory} entity={entity} selectedLLM={selectedLLM}/>
      <CategoryDimension selectedCategory={selectedCategory} entity={entity} />
      <AttributesOverview />
      </div>
    </>
  );
}

let CategoryDimension = React.memo(function ({ selectedCategory, entity }) {
  const discoveryCtx = useContext(DiscoveryContext);
  const id = "purchase_criteria";
  const { checked, uniqueKey } = useIsSelectedSection({ id });

  return (
    <div
      className={classes.section_summary}
      style={{ paddingTop: 10, paddingBottom: 10, marginTop: 20 }}
    >
      <div className="Heading-checkbox">
        <h5>Purchase Criteria</h5>

        {discoveryCtx.state.showReportCheckbox && (
          <Checkbox
            checked={checked}
            onChange={() => {
              discoveryCtx?.clickComponentCheckbox({
                uniqueKey,
                filter: {
                  id: id,
                  title: "Purchase Criteria",
                  tab: tab.competitiveOverview,
                  uniqueKey,
                },
                checked,
                id,
              });
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        )}
      </div>
      <hr />
      <div id={id}>
        <CategoryDimensions category={selectedCategory} entity={entity} />
      </div>
    </div>
  );
});

let TaxonomyAndCoreAttributes = React.memo(function ({selectedCategory,selectedLLM,entity}) {
  const discoveryCtx = useContext(DiscoveryContext);
  const id = "TaxonomyAndCoreAttributes";
  const { checked, uniqueKey } = useIsSelectedSection({ id });
  let title =
    discoveryCtx.type === "brand" ? "Brand Pillars" : "Product Dimension";

  if (discoveryCtx.type === "brand") {
    return (
      <>
        <div className="Heading-checkbox">
          <h5>{title}</h5>

          {discoveryCtx.state.showReportCheckbox && (
            <Checkbox
              checked={checked}
              onChange={() => {
                discoveryCtx?.clickComponentCheckbox({
                  uniqueKey,
                  filter: {
                    id: id,
                    title: title,
                    tab: tab.competitiveOverview,
                    uniqueKey,
                  },
                  checked,
                  id,
                });
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
          )}
        </div>
        <hr />
        <div id={id}>
        {discoveryCtx.type === "brand" ? (
          <CoreAttributes category={selectedCategory} entity={entity} />
        ) : (
          <Taxonomy category={selectedCategory} llm={selectedLLM} />
        )}
        </div>
      </>
    );
  }
});
